// if ($(".dropdown").length) {
//   $(document).on("click", ".dropdown-menu .dropdown-item", function (e) {
//       e.preventDefault();
//       if (!$(this).hasClass("active")) {
//           var swalWithBootstrapButtons = Swal.mixin({
//               customClass: {
//                   confirmButton: "btn btn-primary",
//                   cancelButton: "btn btn-danger me-3",
//               },
//               buttonsStyling: false,
//           });
//           swalWithBootstrapButtons
//               .fire({
//                   title: "Are you sure?",
//                   text: "Do you really want to change your current language!",
//                   icon: "warning",
//                   confirmButtonText: "<i class='fas fa-check-circle me-1'></i> Yes, I am!",
//                   cancelButtonText: "<i class='fas fa-times-circle me-1'></i> No, I'm Not",
//                   showCancelButton: true,
//                   reverseButtons: true,
//                   focusConfirm: true,
//               })
//               .then((result) => {
//                   if (result.isConfirmed) {
//                       if (!$(this).hasClass("active")) {
//                           $(".dropdown-menu .dropdown-item").removeClass("active");
//                           $(this).addClass("active");
//                           $(this)
//                               .parents(".dropdown")
//                               .find(".btn")
//                               .html("<span class='flag-icon flag-icon-us me-1'></span>" + $(this).text());
//                       }
//                       Swal.fire({
//                           icon: "success",
//                           title: "Amazing!",
//                           text: "Your current language has been changed successfully.",
//                           showConfirmButton: false,
//                           timer: 1500,
//                       });
//                   }
//               });
//       }
//   });
// }



//language dropdown

if ($(".dropdown").length) {
    $(document).on("click", ".dropdown-menu .dropdown-item", function (e) {
        e.preventDefault();
        if (!$(this).hasClass("active")) {
            // Remove active class from all dropdown items
            $(".dropdown-menu .dropdown-item").removeClass("active");
            // Add active class to the clicked item
            $(this).addClass("active");
            // Update the dropdown button text
            $(this)
                .parents(".dropdown")
                .find(".btn")
                .html("<span class='flag-icon flag-icon-us me-1'></span>" + $(this).text());
        }
    });
  }



// slider----


  $('.bn_slider').slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    
  });
             
  

    //  //plus minus product details
    //  function onClick(index) {
    //     var clicks = parseInt(document.getElementById("clicks" + index).innerHTML);
    //     clicks += 1;
    //     document.getElementById("clicks" + index).innerHTML = clicks;
    //     document.getElementById("minusbtn" + index).disabled = false;
    // }
    
    // function onUnClick(index) {
    //     var clicks = parseInt(document.getElementById("clicks" + index).innerHTML);
    //     if (clicks > 0) {
    //         clicks -= 1;
    //         document.getElementById("clicks" + index).innerHTML = clicks;
    //     }
    //     if (clicks === 0) {
    //         document.getElementById("minusbtn" + index).disabled = true;
    //     }
    //   }

   //sticky

    document.addEventListener("scroll", () => {
        if (window.scrollY > 200) {
          document.body.classList.add("scrolled");
        } else {
          document.body.classList.remove("scrolled");
        }
      });




      //navbar


  let bomb = document.getElementById('btn0');
  let header = document.getElementById('open');
  let headclose = document.getElementById('closebtn');
  bomb.addEventListener("click", ()=>{
    header.classList.add("isOpen")
	document.body.classList.add("isOpen"); // Add class to body to stop background scroll
  });

  headclose.addEventListener("click", ()=>{
  header.classList.remove("isOpen")
  document.body.classList.remove("isOpen"); // Remove class from body to enable background scroll
  });